import { service } from '../../../service';

const state = {
  loading: false,
  stats: {}
};

const actions = {
  async fetch({ commit, rootState }) {
    commit('setLoading', true);

    return service
      .get(
        `/analytics/${rootState.account.company._id}/${rootState.account.location._id}/temp`
      )
      .then(result => {
        console.log(result);
        commit('setStats', result);
      });
  }
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setStats(state, stats) {
    state.stats = stats;
    state.loading = false;
  }
};

export const temp = {
  namespaced: true,
  state,
  actions,
  mutations
};
